module.exports = __webpack_public_path__ + "static/img/no_search.42fbdf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/default_images/no_search.png
// module id = gm1o
// module chunks = 91